/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnderwritingYear
 */
export interface UnderwritingYear {
    /**
     * The underwriting year.
     * @type {number}
     * @memberof UnderwritingYear
     */
    uwyear: number;
    /**
     * The description of the underwriting year.
     * @type {string}
     * @memberof UnderwritingYear
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UnderwritingYear interface.
 */
export function instanceOfUnderwritingYear(value: object): value is UnderwritingYear {
    if (!('uwyear' in value) || value['uwyear'] === undefined) return false;
    return true;
}

export function UnderwritingYearFromJSON(json: any): UnderwritingYear {
    return UnderwritingYearFromJSONTyped(json, false);
}

export function UnderwritingYearFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnderwritingYear {
    if (json == null) {
        return json;
    }
    return {
        
        'uwyear': json['uwyear'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UnderwritingYearToJSON(json: any): UnderwritingYear {
    return UnderwritingYearToJSONTyped(json, false);
}

export function UnderwritingYearToJSONTyped(value?: UnderwritingYear | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uwyear': value['uwyear'],
        'description': value['description'],
    };
}

